import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <MediaSection />
        <TopicsSection />
        <FaqSection />
        <FeaturesSection />
        <AboutSection />
        <CardsSection />
        <RankingSection />
        <AppSection />
        <IndexSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}